import { useMemo } from 'react';
import { useCVData } from '../lib/cv-mock-data';
import {
  computeCvCompleteness,
  type CvCompletenessModel,
} from '@tabbio/utils/cv-completeness';

export { computeCvCompleteness } from '@tabbio/utils/cv-completeness';
export type {
  CvCompletenessChecklistId,
  CvCompletenessChecklistItem,
  CvCompletenessModel,
} from '@tabbio/utils/cv-completeness';

export function useCvCompleteness(): CvCompletenessModel {
  const { profile, isCvScoped } = useCVData();
  return useMemo(
    () =>
      computeCvCompleteness(profile, { includeJobPreferences: !isCvScoped }),
    [isCvScoped, profile],
  );
}
